module.exports = __webpack_public_path__ + "static/media/Rectangle-1.ec14e90c.png";